import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as notifications from "../../../notifications/notifications";
import { networkKeys } from "../../samples/queryKeys";
import { IPReport } from "../@types";
import api from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultIPReportQueryOptions = (ip: string) => ({
  queryKey: networkKeys.ipReport(ip),
  queryFn: () =>
    api
      .ipReport({
        ip
      })
      .then((r: { data: IPReport }) => r.data)
      .catch((e: AxiosError) => {
        notifications.show({
          level: "error",
          message: `Error encountered while fetching IP Report data. (${
            e.message || e.toString()
          })`
        });
        throw e;
      }),
  keepPreviousData: true,
  enabled: Boolean(ip && cloudEnabled),
  retryOnMount: false,
  ...USEQUERY_DISABLE_REFETCH_OPTIONS
});

const useNetworkThreatIntelIPReport = (ip: string) => {
  const {
    data: ipReport,
    isFetching,
    isSuccess,
    isLoading,
    error,
    refetch
  } = useQuery<IPReport>({
    ...defaultIPReportQueryOptions(ip)
  });

  return { data: ipReport, isFetching, isLoading, isSuccess, error, refetch };
};
export default useNetworkThreatIntelIPReport;
